const percentageFormatter = new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/** "2026-05-01" → Date local (new Date('2026-05-01') la interpreta en UTC y en Argentina muestra el día anterior). */
export function parseIsoDate(value: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
  if (!match) return null
  const [, year, month, day] = match
  return new Date(Number(year), Number(month) - 1, Number(day))
}

/** "2026-05-01" → "01/05/2026". Solo presentación: el dato no se reinterpreta. */
export function formatIsoDate(value: string | null): string {
  if (!value) return ''
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
  if (!match) return value
  const [, year, month, day] = match
  return `${day}/${month}/${year}`
}

export function formatPercentage(value: number): string {
  return `${percentageFormatter.format(value)} %`
}
